import type { ProjectDto } from '@werft/contracts';
import type { OutboxEntry } from './outbox.js';

// Ohne statischen Import des Ausgangskorbs (Zyklus realtime → sync → realtime); projectActions meldet die Quelle an
let source: ((projectId: string) => OutboxEntry[]) | null = null;
export function setPendingSource(fn: (projectId: string) => OutboxEntry[]) {
  source = fn;
}

/**
 * Noch nicht bestätigte Projekteinstellungen (Ausgangskorb `project.update`) über einen Serverstand legen. Sonst setzt
 * die Antwort bzw. das Live-Ereignis einer FRÜHEREN Änderung die sichtbare Einstellung kurz zurück – und eine
 * schnelle Folgeänderung (z. B. zweimal „nach oben“) rechnet auf dem alten Stand und überschreibt die erste.
 */
export function withPendingProject<T extends Partial<ProjectDto>>(projectId: string, p: T, except?: string): T {
  const pending = (source?.(projectId) ?? []).filter((e) => e.kind === 'project.update' && e.opId !== except);
  if (!pending.length) return p;
  const next: Record<string, unknown> = { ...p };
  for (const e of pending) {
    const optimistic = (e.meta as { optimistic?: Record<string, unknown> } | undefined)?.optimistic;
    const patch = optimistic ?? ((e.body as { patch?: Record<string, unknown> }).patch ?? {});
    for (const [k, v] of Object.entries(patch)) if (k !== 'health') next[k] = v;
  }
  return next as T;
}
